import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import i18n from '@/api/i18n/i18n';

dayjs.extend(utc);

export function dateToString(date) {
  return dayjs(date).utc().format('YYYY-MM-DD HH:mm:ss');
}

export function dateToUtc(date) {
  date = dateToString(date);
  date = date.replace(' ', 'T');
  date += '.000Z';
  return date;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return `${`00${date.getUTCDate()}`.slice(-2)}.${`00${date.getUTCMonth() + 1}`.slice(-2)}.${date.getUTCFullYear()}`;
}

export function formatDateToDayString(date) {
  let month = (date.getMonth() + 1).toString();
  if (month.length < 2) month = `0${month}`;
  let day = date.getDate().toString();
  if (day.length < 2) day = `0${day}`;
  const formattedDate = `${day}.${month}.${date.getFullYear().toString().slice(-2)}`;
  return formattedDate;
}

export function convertSecondsToDays(secNum) {
  if (secNum === 0) return `0 ${i18n.t('global.min')}`;

  let minus = false;

  if (secNum < 0) {
    minus = true;
    secNum = -secNum;
  }

  let result = '';

  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum - hours * 3600) / 60);
  const seconds = secNum - hours * 3600 - minutes * 60;

  if (hours > 0) result = `${hours} ${i18n.t('global.h')}. ${minutes} ${i18n.t('global.min')}. `;
  else if (minutes > 0) result = `${minutes} ${i18n.t('global.min')}. `;
  else if (seconds > 0) result = `${i18n.t('global.less')} 1 ${i18n.t('global.min')}`;

  if (minus) result = `-${result}`;

  return result;
}

export function getTime(dateString) {
  const date = new Date(dateString);
  return `${`00${date.getUTCHours()}`.slice(-2)}:${`00${date.getUTCMinutes()}`.slice(
    -2,
  )}:${`00${date.getSeconds()}`.slice(-2)}`;
}

export function getDateUTC(enterDateFrom, enterDateTo) {
  const dateFrom = dayjs(enterDateFrom)
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0)
    .utc(true);

  const dateTo = dayjs(enterDateTo).set('hour', 23).set('minute', 59).set('second', 59)
    .set('millisecond', 0)
    .utc(true);

  return { dateFrom, dateTo };
}

export function getDateUTCFromBuildReport(enterDateFrom, enterDateTo) {
  const dateFrom = dayjs(enterDateFrom).set('millisecond', 0).utc(true);

  const dateTo = dayjs(enterDateTo).set('millisecond', 0).utc(true);

  return { dateFrom, dateTo };
}

export function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ),
  );
}

export const createDateAtString = (timeString) => {
  const [hours, minutes, seconds] = timeString.split(':').map(Number);
  const todayWithTime = new Date();
  todayWithTime.setHours(hours, minutes, seconds, 0);
  return todayWithTime;
};
